import { client } from '../apiClient';
import { GeoChecklistResponse } from '../../models/geo-checklist/GeoChecklistResponse';

type ChecklistType = 'TOPICS_PROMPTS' | 'AI_VISIBILITY';

const GEO_CHECKLIST_ENDPOINT = '/geo-checklist';

export const getGeoChecklist = async (projectId: number): Promise<GeoChecklistResponse> => {
  const { data } = await client(true, true).get<GeoChecklistResponse>(
    `${GEO_CHECKLIST_ENDPOINT}/${projectId}`
  );
  return data;
};

export const toggleGeoChecklistTask = async (
  projectId: number,
  checklistType: ChecklistType,
  taskId: string
): Promise<Record<string, string>> => {
  const { data } = await client(true, true).post<Record<string, string>>(
    `${GEO_CHECKLIST_ENDPOINT}/${projectId}/toggle`,
    { checklistType, taskId }
  );
  return data;
};

export const toggleBatchGeoChecklistTasks = async (
  projectId: number,
  checklistType: ChecklistType,
  taskIds: string[],
  check: boolean
): Promise<Record<string, string>> => {
  const { data } = await client(true, true).post<Record<string, string>>(
    `${GEO_CHECKLIST_ENDPOINT}/${projectId}/toggle-batch`,
    { checklistType, taskIds, check }
  );
  return data;
};

export const resetGeoChecklist = async (
  projectId: number,
  checklistType: ChecklistType
): Promise<Record<string, string>> => {
  const { data } = await client(true, true).post<Record<string, string>>(
    `${GEO_CHECKLIST_ENDPOINT}/${projectId}/reset`,
    { checklistType }
  );
  return data;
};
